module.exports = __webpack_public_path__ + "static/team-e4b2d5370e040c39a5a97eac05a02187.jpg";